import { render, staticRenderFns } from "./OrdersWithStudentToOrionLinking.vue?vue&type=template&id=24105ddf&scoped=true&"
import script from "./OrdersWithStudentToOrionLinking.vue?vue&type=script&lang=js&"
export * from "./OrdersWithStudentToOrionLinking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24105ddf",
  null
  
)

export default component.exports